enum Services {
  SPOTIFY = "SPOTIFY",
  DEEZER = "DEEZER",
  LASTFM = "LASTFM"
}

export default Services;
